import { CircularProgress, Button } from "@mui/material";
import { Dispatch, SetStateAction } from "react";
import Flex from "../../../../../components/Flex";
import { ChatUser } from "./ChatUser";

interface MessageSideBarProps {
  selectedUser: any;
  setCurUser: Dispatch<SetStateAction<any | null>>;
  isLoading?: boolean;
  allUsers?: any[];
}

export const MessageSideBar = ({
  selectedUser,
  setCurUser,
  isLoading,
  allUsers,
}: MessageSideBarProps) => {
  return (
    <Flex
      height={"calc(100svh - 13rem)"}
      flexDirection={"column"}
      gap={1}
      width={"28.35rem"}
      overflow={"scroll"}
    >
      {isLoading && (
        <Flex width={"100%"} justifyContent={"center"}>
          <CircularProgress />
        </Flex>
      )}

      {/* {Array.from({ length: 20 }). */}
      {allUsers?.map((user) => {
        const isSelectedUser = selectedUser?.uuid === user.uuid;

        return (
          <Button
            key={user.uuid}
            fullWidth
            sx={{
              width: "100%",
              height: "auto",
              transition: "background-color 0.3s ease-in",
              backgroundColor: isSelectedUser ? "#EEF7FF" : "transparent",
              boxShadow: "none",
              "&:hover": {
                backgroundColor: isSelectedUser
                  ? "#EEF7FF"
                  : "rgba(0, 0, 0, 0.04)",
                boxShadow: "none",
              },
              "&:active": {
                backgroundColor: isSelectedUser
                  ? "#EEF7FF"
                  : "rgba(0, 0, 0, 0.08)",
                boxShadow: "none",
              },
            }}
            variant="text"
            onClick={() => setCurUser(user)}
          >
            <Flex width={"inherit"} height={"3.2rem"} alignItems={"center"}>
              <ChatUser
                dob={user?.birthDate}
                gender={user?.gender}
                name={user?.patientName}
                message={isSelectedUser ? undefined : user?.lastSms}
                lastOnline={isSelectedUser ? undefined : user?.lastSmsTime}
                recentUnreadMsg={
                  isSelectedUser ? undefined : user?.unReadSmsCount
                }
              />
            </Flex>
          </Button>
        );
      })}
    </Flex>
  );
};
